import { useDeleteSquawkMutation } from "@common/api/quoting/squawk"
import { currentUserQuery } from "@common/api/users"
import { hasPermission } from "@common/lib/permissions"
import { handleError } from "@common/utils"
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/quoting_/squawks/delete/$squawkId",
)({
  beforeLoad: async ({ context: { queryClient } }) => {
    const user = await queryClient.ensureQueryData(currentUserQuery())
    if (
      !hasPermission(user, "squawk:delete") &&
      !hasPermission(user, "squawk:delete_own")
    ) {
      throw redirect({ to: "/" })
    }
  },
  component: DeleteSquawkDialog,
})

function DeleteSquawkDialog(): React.ReactElement {
  const { squawkId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteSquawkMutation()

  const close = () => navigate({ to: "/quoting/squawks", search: true })

  return (
    <DeleteDialog
      noun="squawk"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { squawk_id: squawkId },
          {
            onSuccess: () => {
              showToast("Deleted", "Squawk deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
